module.exports = '<svg width="51" height="32" viewBox="0 0 51 32"><path d="M1.6 6.4h4.8v24A1.6 1.6 0 0 0 8 32h3.2a1.6 1.6 0 0 0 1.6-1.6v-24h4.8a1.6 1.6 0 0 0 1.6-1.6V1.6A1.6 1.6 0 0 0 17.6 0h-16A1.6 1.6 0 0 0 0 1.6v3.2a1.6 1.6 0 0 0 1.6 1.6zm43.92-5.04L38.4 12.8 31.213 1.357C30.743.605 29.648 0 28.762 0H27.2a1.6 1.6 0 0 0-1.6 1.6v28.8a1.6 1.6 0 0 0 1.6 1.6h3.2a1.6 1.6 0 0 0 1.6-1.6V12.525l5.533 8.531c.477.742 1.274.752 1.776.026l5.491-7.984V30.4a1.6 1.6 0 0 0 1.6 1.6h3.2a1.6 1.6 0 0 0 1.6-1.6V1.6A1.6 1.6 0 0 0 49.6 0h-1.638c-.883 0-1.978.605-2.442 1.36z"/></svg>'


//////////////////
// WEBPACK FOOTER
// ./~/li-icons/dist/js/trademark-1.js
// module id = 1454
// module chunks = 14